import * as React from "react";
import SectionName from "../../elements/SectionName";
import FieldDescription from "../../elements/FieldDescription";
import Spacer from "../../elements/Spacer";
import {Button} from "bloomer";


const ExceptionPage = () => {
    return <div className="is-fullwidth has-text-centered">
        <Spacer/>
        <SectionName>Error Occurred</SectionName>
        <FieldDescription>Something went wrong</FieldDescription>
        <Spacer/>
        <Button onClick={() => {
            // @ts-ignore
            window.location = "/";
        }}>Go Back</Button>
    </div>;
};

export default ExceptionPage;


// WEBPACK FOOTER //
// ./src/routes/ErrorPage/ExceptionPage.tsx